<template>
  <div class="container" id="container">
      <a-modal class="" title="新增监测点位" :visible="categoryVisible"  @cancel="closeVisible"  width="70%" @ok="submit" >
        <div>
            <a-form-model :model="categoryList" ref="categoryListRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="检测类别"  prop="pollutantTypeId"  :rules="{
								  required: true,
								  message: '请填写检测类别',
								  trigger: 'change',
								}">
                              <a-select  allowClear placeholder="请选择检测类别"  v-model="categoryList.pollutantTypeId" @change="changeProject">
                                      <a-select-option :value="item.id" v-for="(item, index) in datalist" :key="index">
                                          {{ item.pollutantName }}
                                    </a-select-option>
                              </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="检测点位"  prop="pointName" :rules="{
								  required: true,
								  message: '请填写检测点位',
								  trigger: 'change',
								}">
                                 <a-input allowClear v-model="categoryList.pointName" @change="changePoint" ></a-input>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </div>
        <div>
            <div class="countCase" style="margin: 10px">
                <span>项目列表</span>
                 <a-button type="primary" @click="addCategory" style="margin-right: 5px" :disabled="categoryList.pointName == '' || categoryList.pollutantTypeId =='' ">新增</a-button>
            </div>
            <div>
                  <a-table :data-source="projectList" bordered :loading="loading" :pagination="false" 
				             :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }">
                             <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                                  <template scope="text, record, index">
                                    <!-- {{ (pagination2.current - 1) * 10 + index + 1 }} -->
                                    {{index + 1 }}
                                  </template>
				             </a-table-column>
				             <a-table-column key="item" title="检测项目" ellipsis="true" data-index="item" />
				             <a-table-column key="price" title="单价(元)" ellipsis="true" data-index="price" />
				             <a-table-column key="frequence" title="*频次(次*天)" ellipsis="true" data-index="frequence">
                             <template slot-scope="text, record, index">
								<input class="frequenceInput" type="text" v-model="record.frequence" placeholder="请输入" id="fname" ref="frequenceRef" @click="changeFrequence(text, record, index)" />
							</template>
                            </a-table-column>
				             <a-table-column key="pointNumber" title="*点位数" ellipsis="true" data-index="pointNumber">
                             <template slot-scope="text, record">
                               <a-input v-model="record.pointNumber" placeholder="请输入" @change="changePrice(record)"></a-input>
							</template>
                            </a-table-column>
				             <a-table-column key="sampleNumber" title="*样品数" ellipsis="true" data-index="sampleNumber">
                             <template slot-scope="text, record">
								<a-input v-model="record.sampleNumber" placeholder="请输入" @change="changePrice(record)"></a-input>
							</template>
                            </a-table-column>
				             <a-table-column key="totalPrice" title="小计" ellipsis="true" data-index="totalPrice" >
                             <!-- <template slot-scope="text, record">
                               <a-input v-model="record.totalPrice" placeholder="请输入"></a-input>
							</template> -->
                             </a-table-column>
				             <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
                             <a-table-column title="操作" width="100px">
					            <template scope="text,record,index">
                                   <a @click="deleteProject(index,record)">删除</a>
                                </template>
                             </a-table-column>
                         </a-table>
            </div>
        </div>
     </a-modal>
     <AddProject :addProjectVisible="addProjectVisible " @changeProjectVisible="changeProjectVisible" :addProjectList="addProjectList" :ids="ids" @reshProjectList="getProjectList"></AddProject>

     <div>
          <!-- 表格计算弹窗 -->
      <a-modal  title="请填写频次" :visible="countVisible"   @cancel="closeCount"  width="30%" @ok="submitCount" >
        <div style="margin-bottom: 10px;">
            <span>{{ tableData.item}}</span>
        </div>
        <div>
             <a-form-model :model="frequenceList" ref="frequenceListRef" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item  
                          prop="number"  :rules="{
								  required: true,
								  message: '请填写次数',
								  trigger: 'change',
								}">
                                 <div class="countCase">
                             <a-input  v-model="frequenceList.number" placeholder="请输入"></a-input>
                             <span class="countCaseRight"> 次 </span>
                             <span class="countCaseRight">  * </span>
                        </div>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item  
                           prop="day" :rules="{
								  required: true,
								  message: '请填写天数',
								  trigger: 'change',
								}">
                        <div class="countCase" >
                              <a-input v-model="frequenceList.day" placeholder="请输入"></a-input>
                              <span  class="countCaseRight"> 天</span>
                        </div>

                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
           
            
        </div>
      </a-modal>

     </div>
   
  
  </div>
</template>

<script>
import AddProject from './addProject.vue'
import {getPollotantList, addPointInfo, testItemList, getPollutantInfo, editPointInfo, pointInfoList, getTestItemByPointId, editBatch, deleteItems} from '@/api/surrounding'
// import {VueDebounce} from '@/utils/debounce'
export default {
    components: {
        AddProject
  },
      props: [
        'categoryVisible',
        'rowData',
        'UUID',
        'itemList',
        'environmentList',
        'index',
        'enviromentList',
        'categoryList',
        'projectList'
    ],
    data() {
        return {
            frequenceList: {
              day: undefined,
              number: undefined,
            },
            itemdata: {},
            // categoryList: {
            //     pointId: ''
            // },
            // projectList: [],
            scroll_y: 150,
            datalist: [],
            addProjectVisible: false,
            // 新增项目列表
            addProjectList: [],
            ids: {},
            countVisible: false,
            tableData: {},
            timeout: null
        }
    },
    created() {
        getPollotantList({
            projectId: this.rowData.id
        }).then(res => {
            if(res.code == 200) {
                console.log(res, 'res==============================')
                this.datalist = res.data.list
            } else {
                this.$message.err(res.msg)
            }
        })
            this.$nextTick(() => {
      var max_h = $('#container').height()
      console.log(max_h, 'max_h======================')
      console.log($('.ant-table-header').height() , '2222222222222222222')
      setTimeout(() => {
        this.scroll_y = max_h - 200
      }, 1000)
    })
        // //获得项目列表
        // this.getProjectList()


    },
    methods: {
        changeProject(e) {
            this.categoryList.pointName = ''
            console.log(e,'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
        },
        //获取第二步列表数据
        getEnvironmentList() {
             pointInfoList({
                sheetId: this.UUID,
                subId: this.itemList.id,
                // pointId:  this.categoryList.pointId,

            }).then (res => {
                if(res.code == 200) {
                    console.log(res.data.list, 'res.data.listres.data.listres.data.list')
                    // Object.assign(this.environmentList[this.index], {environmentList:res.data.list})
                    this.$emit('refreshList',res.data.list)
                    
                } else {
                    this.$message.error(res.msg)
                }


            })
        },

        //价格变化事件
        changePrice(record) {
            record.totalPrice = record.price *  record.frequence * record.pointNumber * record.sampleNumber 
        },
        // 频次弹窗提交事件
        submitCount() {
              this.$refs.frequenceListRef.validate((valid) => {
            if(valid) {
            this.tableData.frequence = this.frequenceList.day * this.frequenceList.number
            this.changePrice(this.tableData)
            this.frequenceList.day = '' 
            this.frequenceList.number = ''
            this.countVisible = false

            console.log( this.tableData, ' this.tableData==================')
            }
              })


        },
        closeCount() {
             this.$refs.frequenceListRef.resetFields()
             this.countVisible = false

        },
        //频次
        changeFrequence(text, record, index) {
            console.log(text, record, index, '111111111111111111111')
            // document.getElementById("fname").style.backgroundColor = "red";
            console.log('333333333333333333333333')
            this.countVisible = true
            this.tableData = record

            console.log(record, 'record======================')

        },
        // 提交事件
        submit() {
            this.$refs.categoryListRef.validate((valid) => {
            if(valid) {
                 if(this.projectList.length == 0) {
                        this.$message.warning('新增项目列表不可为空！')

                    }else {
                 this.projectList.forEach(item => {
                if (item.pointNumber == null||item.pointNumber == '' || item.sampleNumber== null ||  item.sampleNumber== ''|| item.frequence == null || item.frequence == '') {
                    this.$message.warning('请填写表格必填项')
                } else {
                    
            console.log(this.projectList, 'projectList=======================')
            this.projectList.forEach(item => {
                  Object.assign( item, {
                     sheetId: this.UUID,
                subId: this.itemList.id,
                pointId:  this.categoryList.pointId,
                pollutantName: item.item
 
            })

            })
          
            editBatch({
                quoteTestItemDTOList: this.projectList

            }).then (res => {
                console.log(res.data)
                if(res.code == 200) {
                    this.getEnvironmentList()
                     this.categoryList.pointId = ''
                     this.categoryList = {}
                     this.projectList.frequence = ''
                     this.projectList = []
                    this.categoryVisible = false

                } else {
                    this.$message.error(res.msg)
                }

            })

                }
            })
                   }


            }
            })
           

        },
        //获得项目列表
        getProjectList() {
           
            getTestItemByPointId({
                sheetId: this.UUID,
                subId: this.itemList.id,
                pointId:  this.categoryList.pointId,
                pollutantTypeId: this.categoryList.pollutantTypeId

            }).then (res => {
                if(res.code == 200) {
                    console.log(this.enviromentList[this.index], 'this.enviromentList[this.index]=======================')
                        if(this.enviromentList[this.index].id == 6) {
                            this.frequenceList = {
                                number: 3,
                                day: 1
                            }
                            res.data.forEach(item => {
                                item.frequence = 3
                            })
                        }else if (this.enviromentList[this.index].id == 7) {
                            this.frequenceList = {
                                number: 3,
                                day: 2
                            }
                            res.data.forEach(item => {
                                item.frequence = 6
                            })
                        }else if (this.enviromentList[this.index].id == 8) {
                            this.frequenceList = {
                                number: 4,
                                day: 7
                            }
                            res.data.forEach(item => {
                                item.frequence = 28
                            })
                        }
                    this.projectList = res.data
                } else {
                    this.$message.error(res.msg)
                }


            })

        },
        changeProjectVisible(data) {
            this.addProjectVisible = data

        },
        //关闭弹窗
        closeVisible() {
             this.categoryList.pollutantTypeId = ''
             this.categoryList.pointName = ''
             this.categoryList.pointId = ''
            this.projectList = []
             this.$refs.categoryListRef.resetFields()
            this.categoryVisible = false
            this.$emit('changeCategoryVisible',this.categoryVisible )

        },
        //删除报价检测项目
        deleteProject(index,record) {
             //删除
             console.log(index, 'indexindexindexindexindexindex')
            console.log(record, 'recordrecordrecordrecord')
            deleteItems(record.id).then(res => {
                if(res.code == 200) {
                    this.$message.success(res.msg)
                    //刷新页面
                    this.projectList.splice(index, 1)
                    // this.getProjectList()
                } else {
                    this.$message.error(res.msg)
                }

            })
        },

        //点位数
        // changePoint(){
        //           let lastTime = null // 记录上一次运行的时间
        //           let timer = null
        // let now = new Date().getTime()
        // if (!lastTime ) lastTime = now
        // // 当上一次执行的时间与当前的时间差大于设置的执行间隔时长的话，就主动执行一次
        // if (now - lastTime > 1000) {
        //     clearTimeout(timer)
        //     // this.getPointId()
        //     // fun().apply(this, arguments)
        //     lastTime = now // 执行函数后，马上记录当前时间
        // } else {
        //     clearTimeout(timer)
        //     timer = setTimeout(() => {
        //          this.getPointId()
        //     }, 2000)
        // }
        // },
            // VueDebounce("getPointId", 2000)
     changePoint(){
        console.log(this.timeout, 'this.timeout======================')
        //  if (this.timeout) {
            clearTimeout(this.timeout)
        //     return
        //  }
         this.timeout = setTimeout(() => {
            //取监测点位
           this.getPointId()
         }, 1000)
        },
    getPointId() {
        if(this.categoryList.pollutantTypeId != '' && this.categoryList.pointName != '') {
            console.log(this.categoryList.pointId, 'this.categoryList.pointIdthis.categoryList.pointId')
            if(this.categoryList.pointId ){
                console.log('99999999999999999999999999')
                //调用修改接口
                editPointInfo({
                    sheetId: this.UUID,
                    subId: this.itemList.id,
                    pointName: this.categoryList.pointName,
                    id: this.categoryList.pointId

                }).then(res => {
                    this.$message.success(res.msg)
                    // this.categoryList.pointId = res.data.id
                })
            } else {
                    console.log('888888888888888888888')
                // 调用新增接口
                addPointInfo({
                    sheetId: this.UUID,
                    subId: this.itemList.id,
                    pointName: this.categoryList.pointName

                }).then(res => {
                    console.log(res, '22222222222222222222222222')
                    this.categoryList.pointId = res.data.id
                })
            }

        }

    },
        //新增事件
        addCategory() {
            // window.open('http://192.168.0.204:8787/exportPdf')
            //   this.$refs.categoryListRef.validate((valid) => {
                if(this.categoryList.pointId) {
                    console.log('111111111111111111111111111111')
                    var quoteTestItem = {}
                    var quoteCategoryPollutant = {}
                    console.log(quoteTestItem,quoteCategoryPollutant,'=============================')
                    console.log( this.enviromentList[this.index], ' this.enviromentList[this.index]')
                     Object.assign(quoteCategoryPollutant, {
                        masterCategoryId: this.enviromentList[this.index].masterCategoryId,
                        //子分类
                        subCategoryId: this.enviromentList[this.index].subCategoryId,
                        //检测类别id
                        pollutantTypeId: this.categoryList.pollutantTypeId


                    })

                    Object.assign(quoteTestItem, {
                         sheetId: this.UUID,
                        subId: this.itemList.id,
                        pointId:  this.categoryList.pointId,
                    })
                      Object.assign(this.ids, {
                        sheetId: this.UUID,
                        subId: this.itemList.id,
                        pointId:  this.categoryList.pointId,
                        pollutantTypeId: this.categoryList.pollutantTypeId
                    })
                    console.log(quoteTestItem,quoteCategoryPollutant,'=============================')
                    getPollutantInfo({
                       quoteCategoryPollutant: quoteCategoryPollutant,
                        quoteTestItem: quoteTestItem

                    }).then(res => {
                        if(res.code == 200) {
                            this.addProjectList = res.data
                           this.addProjectVisible = true
                        }else {
                            this.$message.error(res.msg)
                        }

                    })

                }
            //   })


        }

    }

}
</script>

<style>
.countCase {
    display: flex;
    justify-content: space-between;
    margin: 0 20px;

}
.countRight {
    margin-left: 30px;
}
.countCaseRight {
    font-size: 20px;
    margin-left: 10px;
    height: 32px;
    line-height: 32px;
}
.frequenceInput {
    width: 100%;
    height: 30px;
    border-radius: 5px;
    border: none;
    -webkit-appearance:none;/*去除阴影边框*/
    border: 1px solid rgb(222, 219, 219);
    outline: none;
    -webkit-tap-highlight-color: rgb(210, 207, 207);/*点击高亮的颜色*/
}
.container {
    height: 100%;
}

</style>